import { CursorObserverSettings } from './cursorObserverSettings';
import { IdleObserverSettings } from './idleObserverSettings';

export type ExitIntentTriggerSettings = {
  /**
   * milliseconds to delay the detection of exit intent action.
   */
  detectionDelayMillis: number;
  /**
   * override settings for internal used CursorObserver to detect mouse leaving the viewport.
   */
  cursorObserver?: CursorObserverSettings;
  /**
   * override settings for internal used IdleObserver to detect use idle times.
   */
  idleObserver?: IdleObserverSettings;
};

export type ExitIntentSessionSettings = {
  /**
   * settings to control when a trigger can be fired.
   */
  trigger: {
    /**
     * minimum number of pages the user must have visited before the exit intent can trigger first.
     */
    minPageVisits: number;
    /**
     * maximum number of trigger calls in a user session.
     */
    maxTriggers: number;
    /**
     * days to disable the trigger if the disabledEvent is caught.
     */
    disabledDays?: number;
  };
};

export type ExitIntentSettings = {
  /**
   * general settings affect the triggering action.
   */
  trigger: ExitIntentTriggerSettings;
  /**
   * settings for the session management of the exit intent.
   */
  session: ExitIntentSessionSettings;
};

export const exitIntentDefaultSettings: ExitIntentSettings = {
  trigger: {
    detectionDelayMillis: 8000,
  },
  session: {
    trigger: { maxTriggers: 3, minPageVisits: 3, disabledDays: 30 },
  },
} as unknown as ExitIntentSettings;
